import React from "react";
import { Row, Col, Card } from "antd";
import "./index.css";
import coverProfile from "../../assets/images/login-bg.jpg";
import profile from "../../assets/images/rider.png";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";

import { MdModeEditOutline } from "react-icons/all";
const CoverImage = ({
  userImage,
  CoverImage,
  onChangeCoverImage,
  onChangeProfileImage,
  keyTab,
  onChangeBusinessImage,
}) => {
  let profileImageRef;
  let coverImageRef;

  return (
    <>
      <Row>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{
            height: "40vh",
            backgroundSize: "cover",
            backgroundImage: `url(${CoverImage})`,
            width: "100%",
            maxHeight: "38vh",
            backgroundColor: "grey",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          <Row justify="end">
            <Col xl={24} lg={24}>
              <Row justify="end" align="middle">
                <Col
                  style={{ padding: "1rem", background: "rgba(0, 0, 0, 0.26)" }}
                >
                  <span className="color-white text-right">
                    Edit Store Cover Image
                  </span>
                  <span
                    className="pointer-cursor"
                    onClick={() => coverImageRef.click()}
                  >
                    <Fab
                      color="primary"
                      aria-label="edit"
                      sx={{
                        "&.MuiFab-primary": { background: "#26a69a" },
                      }}
                      size="small"
                    >
                      <EditIcon />
                    </Fab>{" "}
                  </span>
                </Col>
              </Row>
              <Row
                gutter={[0, 0]}
                style={{ position: "relative" }}
                justify="end"
              >
                <Col
                  xs={18}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  className="profileimage profile-img"
                  style={{
                    // height: "160px",
                    // borderRadius: "50%",
                    // backgroundSize: "cover",
                    // backgroundPosition: "center center",
                    backgroundImage: `url(${
                      keyTab == 2
                        ? userImage?.rmx_company_asset.logo?.original
                        : userImage?.image?.original
                    })`,
                    // position: "absolute",
                    // top: "90px",
                    // right: "85%",
                    // left: 0,
                    // width: "160px",
                    // marginLeft: "12px",
                  }}
                >
                  <Row justify="end">
                    <Col
                      className="pointer-cursor"
                      onClick={() => profileImageRef.click()}
                    >
                      <Fab
                        color="primary"
                        aria-label="edit"
                        sx={{
                          "&.MuiFab-primary": { background: "#26a69a" },
                        }}
                        size="small"
                      >
                        <EditIcon />
                      </Fab>{" "}
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={12}
                  className={keyTab == "2" ? "keyTab2" : "keyTab1"}
                >
                  <h1
                    className="profileHeading profile-headings"
                    // style={{ fontSize: "20px", color: "white" }}
                  >
                    {keyTab == "2"
                      ? `Welcome to ${userImage?.business_name}`
                      : ` Hello, ${userImage?.first_name} ${userImage?.last_name}!`}
                  </h1>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <input
          type="file"
          ref={(ref) => (profileImageRef = ref)}
          className="d-none"
          onChange={(e) => {
            keyTab == "2" ? onChangeBusinessImage(e) : onChangeProfileImage(e);
          }}
        />
        <input
          type="file"
          ref={(ref) => (coverImageRef = ref)}
          className="d-none"
          onChange={(e) => {
            onChangeCoverImage(e, userImage);
          }}
        />
      </Row>
    </>
  );
};
export default CoverImage;
